var _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 20,
    viewBox: "0 0 140 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 113,
    height: 3,
    fill: "#437689"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#437689"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 10,
    r: 10,
    fill: "#437689"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 10,
    r: 10,
    fill: "#437689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage3);
export default __webpack_public_path__ + "static/media/page3.382cdc62f2100a17ed38b9a324eeb85e.svg";
export { ForwardRef as ReactComponent };